var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTerzoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.12569 1.17169C6.62154 1.96569 6.38169 2.36969 6.38169 2.42508C6.38169 2.482 6.99615 3.47169 8.40015 5.67585C9.51015 7.41892 10.4975 8.96662 10.594 9.11523L10.7698 9.38539L11.0497 8.76385C11.4282 7.92292 11.5203 7.67662 11.5918 7.31246C11.738 6.56954 11.6143 5.67585 11.2777 5.04123C11.1831 4.86277 8.09523 0.182769 7.98692 0.0535385C7.96231 0.024 7.92585 0 7.90585 0C7.886 0 7.53492 0.527231 7.12569 1.17169ZM5.78738 5.13123C5.09431 5.28215 4.42046 5.69692 4.00062 6.23108C3.67385 6.64677 0.00384615 12.1443 0.002 12.2211L0 12.2974L1.60415 12.3052C2.94569 12.3118 3.21508 12.3062 3.24969 12.2705C3.27246 12.2471 3.71662 11.6009 4.23677 10.8346C4.75677 10.0683 5.19108 9.44123 5.20154 9.44108C5.21231 9.44092 5.39692 9.74662 5.61231 10.1205C6.04815 10.8769 6.24615 11.1638 6.49662 11.4028C7.04 11.9206 7.70462 12.2191 8.45046 12.2805C8.62369 12.2948 10.3912 12.2974 12.3782 12.2866C15.714 12.2683 15.9912 12.2629 16 12.216C16.0103 12.1606 14.3828 9.55092 14.2835 9.46369C14.2262 9.41323 13.9655 9.41015 9.72477 9.41015C7.25092 9.41015 5.22754 9.39985 5.22862 9.38723C5.22969 9.37462 5.86754 8.42938 6.64615 7.28677C7.42477 6.14415 8.05846 5.20523 8.05446 5.20015C8.036 5.17754 6.60277 5.07246 6.33723 5.074C6.17231 5.07523 5.92892 5.10046 5.78738 5.13123Z",
    fill: "#9966FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerzoIcon);
export default __webpack_public_path__ + "static/media/TerzoIcon.e942e00b1bdca69aa39da88252f32636.svg";
export { ForwardRef as ReactComponent };